/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTrendingUp2 = createReactComponent("trending-up-2", "IconTrendingUp2", [
  ["path", { d: "M18 5l3 3l-3 3", key: "svg-0" }],
  ["path", { d: "M3 18h5l7 -10h6", key: "svg-1" }]
]);

export { IconTrendingUp2 as default };
//# sourceMappingURL=IconTrendingUp2.js.map
